import { Drawer, Spin, Form, Checkbox, Button } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import useEnrollmentUpdate from '../../../../../../../hooks/useEnrollmentUpdate';
import useMobileBreakpoint from '../../../../../../../hooks/useMobileBreakpoint';

const DrawerInstitutionalProfile = ({ visible, closeDrawer, title, form }) => {
  const [updateEnrollment, isLoading] = useEnrollmentUpdate();

  const isMobile = useMobileBreakpoint();

  const handleSubmit = async ({ institutionalInvestorDeclaration }) => {
    const updatePayload = {
      institutionalInvestorDeclaration,
      enrollmentInvestorProfile: {
        isInstitutionalInvestor: true,
      },
    };

    updateEnrollment(updatePayload);
    closeDrawer();
  };

  return (
    <Drawer
      title="Declaración de Inversionista Institucional"
      width={isMobile ? null : 720}
      onClose={() => {
        closeDrawer();
      }}
      visible={visible}
      bodyStyle={{ paddingBottom: 80 }}
    >
      <Spin spinning={isLoading}>
        <p className="drawerInstitutional__title">{title}</p>
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <p>
            El cliente firmante cuyos datos se individualizan en el cuerpo del Contrato al cual
            accede el presente Anexo, declara que SÍ es un inversionista institucional.
          </p>
          <p>
            El Suscrito, en su calidad de Inversionista Institucional de acuerdo a lo establecido en
            la Sección I de la Norma de Carácter General Nº 410 de 2016 impartida por la Comisión
            para el Mercado Financiero, bajo juramento viene en declarar su intención expresa de
            participar e invertir en el mercado financiero a través de instrumentos con condiciones
            y requisitos específicos, entre los cuales se encuentran a título meramente ejemplar y
            enunciativo, valores de oferta pública de emisores nacionales y/o extranjeros, cuotas o
            series de cuotas de fondos mutuos y/o de inversión, dirigidos a Inversionistas
            Calificados, acciones o participaciones de vehículos de inversión colectiva extranjeros,
            contratos de derivados celebrados en Chile o en el extranjero con el propósito de cubrir
            el riesgo de fluctuaciones de tasas, precios y tipos de cambio de los activos
            administrados, contratos sobre productos agropecuarios que se transen en bolsas de
            productos nacionales, facturas que sean adquiridas en centros bursátiles nacionales que
            cuenten con autorización para transar este tipo de activos, notas estructuradas;
            contrato de préstamo de valores y cualesquiera otro instrumento financiero que pudiera
            desarrollarse en el futuro. Asismismo, el(la) Suscrito(a) declara expresamente que
            entiende a cabalidad y acepta todos los riesgos propios de los mercados especiales y sus
            instrumentos, y que cumple con los requisitos establecidos en la NCG Nº216 para ser
            considerado como Inversionista Calificado.
          </p>

          <p>
            A mayor abundamiento, y a fin de precisar lo previamente referido, el(la) Suscrito(a)
            declara ser una persona o entidad:
          </p>

          <Form.Item
            name={['institutionalInvestorDeclaration', 'isForeignWithBankBusinessRegulation']}
            valuePropName="checked"
          >
            <Checkbox>
              Extranjera cuyo giro principal está sometido a la regulación aplicable al giro
              bancario, de compañías de seguros o reaseguros conforme al marco jurídico aplicable en
              su país de origen.
            </Checkbox>
          </Form.Item>
          <Form.Item
            name={['institutionalInvestorDeclaration', 'isCollectiveInvestmentVehicle']}
            valuePropName="checked"
          >
            <Checkbox>
              Fondo u otro tipo de vehículo de inversión colectiva, en uno u otro caso extranjero, y
              que cumple al menos una de las siguientes condiciones:
            </Checkbox>
          </Form.Item>
          <Form.Item
            name={['institutionalInvestorDeclaration', 'itsInvestDecisionsAreMadeByAuditedEntity']}
            valuePropName="checked"
            style={{ marginLeft: '22px' }}
          >
            <Checkbox>
              Que el órgano a cargo de sus decisiones de inversión o sus propios administradores
              desempeñando esa función, son fiscalizados en su calidad de tales por un organismo
              público o privado de similar competencia a la Comisión para el Mercado Financiero o a
              la Superintendencia de Pensiones.
            </Checkbox>
          </Form.Item>
          <Form.Item
            name={['institutionalInvestorDeclaration', 'isAuditedAsCollectiveInvestmentVehicle']}
            valuePropName="checked"
            style={{ marginLeft: '22px' }}
          >
            <Checkbox>
              Que está sometido, en su calidad de fondo o vehículo de inversión colectiva, a la
              fiscalización por parte de su organismo de similar competencia a la Comisión para el
              Mercado Financiero o a la Superintendencia de Pensiones.
            </Checkbox>
          </Form.Item>

          <Form.Item
            name={['institutionalInvestorDeclaration', 'isPrivateInvestmentFundLaw20712']}
            valuePropName="checked"
          >
            <Checkbox>
              Fondo de inversión privado de la ley que regula la Administración de Fondos de
              Terceros y Carteras Individuales aprobada por el artículo 1 de la Ley Nº 20.712 de
              2014, que cumple con al menos una de las siguientes condiciones:
            </Checkbox>
          </Form.Item>
          <Form.Item
            name={[
              'institutionalInvestorDeclaration',
              'haveHadAtLeastFourContributorsWithTenPercent',
            ]}
            valuePropName="checked"
            style={{ marginLeft: '22px' }}
          >
            <Checkbox>
              Que, durante 12 de los últimos 18 meses contados a partir de esta fecha, hayan tenido
              al menos cuatro aportantes, no relacionados entre sí, en que cada uno de ellos tuvo
              más del 10% del patrimonio del fondo.
            </Checkbox>
          </Form.Item>
          <Form.Item
            name={['institutionalInvestorDeclaration', 'haveHadAuditedContributors']}
            valuePropName="checked"
            style={{ marginLeft: '22px' }}
          >
            <Checkbox>
              Que, durante 12 de los últimos 18 meses contados a partir de esta fecha, haya tenido
              como aportante a uno o más fondos fiscalizados por la Comisión para el Mercado
              Financiero, a compañías de seguros, bancos o a las entidades a que se refiere el
              párrafo siguiente, y siempre que la participación total que hayan tenido ese tipo de
              entidades en el fondo durante ese preíodo sea igual o superior al 50% de las cuotas
              pagadas del fondo.
            </Checkbox>
          </Form.Item>
          <Form.Item
            name={[
              'institutionalInvestorDeclaration',
              'isInscribedInThePortfolioAdministrationRegistry',
            ]}
            valuePropName="checked"
          >
            <Checkbox>
              Inscrita en el Registro de Administradores de Carteras mantenido por Comisión para el
              Mercado Financiero, y que cumplan al menos una de las siguientes condiciones:
            </Checkbox>
          </Form.Item>

          <Form.Item
            name={[
              'institutionalInvestorDeclaration',
              'administratesMoreThanFiftyConstituentsPortfolios',
            ]}
            valuePropName="checked"
            style={{ marginLeft: '22px' }}
          >
            <Checkbox>
              Administra carteras para 50 o más mandantes no pertenecientes a la misma familia,
              conforme a la definición contenida en la letra d) del artículo 1 de la Ley Nº 20.712,
              por un monto total igual o superior al equivalente a 500.000 unidades de fomento.
            </Checkbox>
          </Form.Item>
          <Form.Item
            name={[
              'institutionalInvestorDeclaration',
              'administratesPortfoliosOfMoreThan1000000TotalUf',
            ]}
            valuePropName="checked"
            style={{ marginLeft: '22px' }}
          >
            <Checkbox>
              Administra una o más carteras por un monto total igual o superior al equivalente a
              1.000.000 unidades de fomento.
            </Checkbox>
          </Form.Item>
          <Form.Item
            name={['institutionalInvestorDeclaration', 'isGubernamentalSupernationalOrStatal']}
            valuePropName="checked"
          >
            <Checkbox>
              Gubernamental o estatal, o un fondo soberano, autorizado para invertir en instrumentos
              financieros del mercado de capitales, entre otras inversiones.
            </Checkbox>
          </Form.Item>
          <Form.Item
            name={[
              'institutionalInvestorDeclaration',
              'isOrganismThatPromotesCapitalMarketDevelopment',
            ]}
            valuePropName="checked"
          >
            <Checkbox>
              Organismo multilateral, supernacional o entidad creada por varios estados cuyos
              recursos tengan por destino promover el desarrollo de los mercados de capitales.
            </Checkbox>
          </Form.Item>

          <p>Declara que finalmente el(la) Suscrito(a):</p>

          <ol>
            <li>
              Que los valores y sus emisores pueden contar con requisitos, parámetros y riesgos
              diferentes a aquellos correspondientes al mercado general de valores, razón por la que
              sólo pueden participar Inversionistas Calificados.
            </li>
            <li>
              Que la Comisión para el Mercado financiero, en consideración a las características de
              determinados emisores de valores, al volumen de sus operaciones u otras
              circunstancias, está legalmente facultada para requerirles menor información y
              circunscribir la transacción de sus valores a los grupos de inversionistas que
              determine.
            </li>
            <li>
              Que en virtud de lo anterior, la Comisión para el Mercado Financiero, a través de
              Normas de Carácter General, ha establecido menores requisitos de información para
              aquellos emisores que pretendan hacer oferta de sus valores en mercado especiales o
              dirigirlas exclusivamente a Inversionistas Calificados
            </li>
            <li>
              Que, tratándose de valores extranjeros, la información legal, económica y financiera
              corresponderá a aquella que el emisor entrega en sus mercados de origen o en otros
              mercados donde los valores se negocian, y que la oferta pública de valores extranjeros
              en Chile requiere de parte de la Comisión para el Mercado Financiero únicamente de la
              inscricpión en el Registro de Valores Extranjeros que lleva al efecto, por lo cual
              sólo le compete la regulación y supervisión de la oferta pública que de dichos títulos
              se haga en Chile, con las limitaciones que conlleva que los emisores respectivos
              tengan domicilio en el extranjero.
            </li>
          </ol>

          <p>
            La presenta declaración se suscribe en duplicado, entregándose en este mismo acto a un
            ejemplar firmado de la misma inversionista, mientras que el otro permanecerá en las
            oficinas de Grupo Vantrust Capital S.A
          </p>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Confirmar
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </Drawer>
  );
};

DrawerInstitutionalProfile.propTypes = {
  visible: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  closeDrawer: PropTypes.func.isRequired,
  form: PropTypes.objectOf.isRequired,
};

export default DrawerInstitutionalProfile;
